import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormsModule, ValidatorFn, Validators } from '@angular/forms';

import { Router, NavigationStart } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { EmailTemplateService, ImportInvoiceApplicantService } from '../../services'
import { SharedService } from '../../../shared/services';
import { ImportInvoicedApplicants, InvoiceApplicants } from 'src/app/admin/models';
import { EmailValidator, NameValidator, PhoneValidator,BillRateValidator, isNullValidator, ExperienceValidator,isCompareDateValidator, ApplicantNameValidator} from '../../../shared/validators';
import * as XLSX from 'xlsx';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { JwtService } from 'src/app/auth/services';
import { TitleCasePipe } from '@angular/common';

@Component({
  selector: 'app-import-invoice-applicant',
  templateUrl: './import-invoice-applicant.component.html',
  styleUrls: ['./import-invoice-applicant.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class ImportInvoiceApplicantComponent implements OnInit {
  importInvoiceApplicantForm:FormGroup;
  tempid: number = 0;
  importInvoiceFile: File;
  arrayBuffer: any;
  arraylist: any;
  importInvoicedApplicants: ImportInvoicedApplicants;
  public invoiceApplicants: InvoiceApplicants[] = [];
  processedApplicants: InvoiceApplicants[] = [];
  rejectedApplicants: InvoiceApplicants[] = [];
  validatedApplicants: InvoiceApplicants[] = [];
  uploadedFileName = "";
  loading = false;
  isShowInputTable = false;
  isShowResultTable = false;
  isValidateTable = false;
  disableImportBtn = false;
  displayErrorModal = false;
  invoiceApplicantAllColumns = [
    { value: 'rowId', header: 'Row ID', width: '4rem' },
    { value: 'firstName', header: 'First Name', width: '7rem'  },
    { value: 'lastName', header: 'Last Name', width: '7rem' },
    { value: 'email', header: 'Email', width: '7rem' },
    { value: 'phone', header: 'Phone', width: '7rem' },
    { value: 'stateName', header: 'State', width: '7rem' },
    { value: 'city', header: 'City', width: '7rem' },
    { value: 'experience', header: 'Experience', width: '7rem' },
    { value: 'applicantClassification', header: 'Applicant Classification', width: '7rem' },
    { value: 'availableStatus', header: 'Available Status', width: '7rem' },
    { value: 'hourlyBillRate', header: 'Hourly Bill Rate', width: '7rem' },
    { value: 'residentialStatus', header: 'Residential Status', width: '7rem' },
    { value: 'requisitionTitle', header: 'Requisition Title', width: '7rem' },
    { value: 'billRate', header: 'Req. Bill Rate', width: '7rem' },
    { value: 'jobCategory', header: 'Job Category', width: '7rem' },
    { value: 'contractType', header: 'Contract Type', width: '7rem' },
    { value: 'jobSite', header: 'Job Site', width: '7rem' },
    { value: 'payType', header: 'Pay Type', width: '7rem' },
    { value: 'hireType', header: 'Hire Type', width: '7rem' },
    { value: 'clientName', header: 'Client', width: '7rem' },
    { value: 'clientDepartment', header: 'Client Dept', width: '7rem' },
    { value: 'vendorName', header: 'Vendor', width: '7rem' },
    { value: 'startDate', header: 'Start Date', width: '7rem' },
    { value: 'endDate', header: 'End Date', width: '7rem' }
  ];

  processedInvoiceApplicantAllColumns = [
    { value: 'rowId', header: 'Row Id', width: '4rem'  },
    { value: 'firstName', header: 'First Name', width: '7rem'  },
    { value: 'lastName', header: 'Last Name', width: '7rem' },
    { value: 'email', header: 'Email', width: '7rem' },
    { value: 'phone', header: 'Phone', width: '7rem' },
    { value: 'stateName', header: 'State', width: '7rem' },
    { value: 'city', header: 'City', width: '7rem' },
    { value: 'experience', header: 'Experience', width: '7rem' },
    { value: 'applicantClassification', header: 'Applicant Classification', width: '7rem' },
    { value: 'availableStatus', header: 'Available Status', width: '7rem' },
    { value: 'hourlyBillRate', header: 'Hourly Bill Rate', width: '7rem' },
    { value: 'residentialStatus', header: 'Residential Status', width: '7rem' },
    { value: 'requisitionTitle', header: 'Requisition Title', width: '7rem' },
    { value: 'billRate', header: 'Req. Bill Rate', width: '7rem' },
    { value: 'jobCategory', header: 'Job Category', width: '7rem' },
    { value: 'contractType', header: 'Contract Type', width: '7rem' },
    { value: 'jobSite', header: 'Job Site', width: '7rem' },
    { value: 'payType', header: 'Pay Type', width: '7rem' },
    { value: 'hireType', header: 'Hire Type', width: '7rem' },
    { value: 'clientName', header: 'Client', width: '7rem' },
    { value: 'clientDepartment', header: 'Client Dept', width: '7rem' },
    { value: 'vendorName', header: 'Vendor', width: '7rem' },
    { value: 'startDate', header: 'Start Date', width: '7rem' },
    { value: 'endDate', header: 'Est. End Date', width: '7rem' },
    { value: 'importStatus', header: 'Status', width: '7rem' },
    { value: 'importDescription', header: 'Description', width: '7rem' }
  ];
  rejectedInvoiceApplicantAllColumns = [
    { value: 'rowId', header: 'Row Id', width: '7rem' },
    { value: 'firstName', header: 'First Name', width: '7rem' },
    { value: 'lastName', header: 'Last Name', width: '7rem' },
    { value: 'email', header: 'Email', width: '7rem' },
    { value: 'phone', header: 'Phone', width: '7rem' },
    { value: 'stateName', header: 'State', width: '7rem' },
    { value: 'city', header: 'City', width: '7rem' },
    { value: 'experience', header: 'Experience', width: '7rem' },
    { value: 'applicantClassification', header: 'Applicant Classification', width: '7rem' },
    { value: 'availableStatus', header: 'Available Status', width: '7rem' },
    { value: 'hourlyBillRate', header: 'Hourly Bill Rate', width: '7rem' },
    { value: 'residentialStatus', header: 'Residential Status', width: '7rem' },
    { value: 'requisitionTitle', header: 'Requisition Title', width: '7rem' },
    { value: 'billRate', header: 'Req. Bill Rate', width: '7rem' },
    { value: 'jobCategory', header: 'Job Category', width: '7rem' },
    { value: 'contractType', header: 'Contract Type', width: '7rem' },
    { value: 'jobSite', header: 'Job Site', width: '7rem' },
    { value: 'payType', header: 'Pay Type', width: '7rem' },
    { value: 'hireType', header: 'Hire Type', width: '7rem' },
    { value: 'clientName', header: 'Client', width: '7rem' },
    { value: 'clientDepartment', header: 'Client Dept', width: '7rem' },
    { value: 'vendorName', header: 'Vendor', width: '7rem' },
    { value: 'startDate', header: 'Start Date', width: '7rem' },
    { value: 'endDate', header: 'Est. End Date', width: '7rem' },
    { value: 'importStatus', header: 'Status', width: '7rem' },
    { value: 'importDescription', header: 'Description', width: '7rem' }
  ];
  validatedInvoiceApplicantAllColumns = [
    { value: 'rowId', header: 'Row Id', width: '7rem' },
    { value: 'firstName', header: 'First Name', width: '7rem' },
    { value: 'lastName', header: 'Last Name', width: '7rem' },
    { value: 'email', header: 'Email', width: '7rem' },
    { value: 'phone', header: 'Phone', width: '7rem' },
    { value: 'stateName', header: 'State', width: '7rem' },
    { value: 'city', header: 'City', width: '7rem' },
    { value: 'experience', header: 'Experience', width: '7rem' },
    { value: 'applicantClassification', header: 'Applicant Classification', width: '7rem' },
    { value: 'availableStatus', header: 'Available Status', width: '7rem' },
    { value: 'hourlyBillRate', header: 'Hourly Bill Rate', width: '7rem' },
    { value: 'residentialStatus', header: 'Residential Status', width: '7rem' },
    { value: 'requisitionTitle', header: 'Requisition Title', width: '7rem' },
    { value: 'billRate', header: 'Req. Bill Rate', width: '7rem' },
    { value: 'jobCategory', header: 'Job Category', width: '7rem' },
    { value: 'contractType', header: 'Contract Type', width: '7rem' },
    { value: 'jobSite', header: 'Job Site', width: '7rem' },
    { value: 'payType', header: 'Pay Type', width: '7rem' },
    { value: 'hireType', header: 'Hire Type', width: '7rem' },
    { value: 'clientName', header: 'Client', width: '7rem' },
    { value: 'clientDepartment', header: 'Client Dept', width: '7rem' },
    { value: 'vendorName', header: 'Vendor', width: '7rem' },
    { value: 'startDate', header: 'Start Date', width: '7rem' },
    { value: 'endDate', header: 'Est. End Date', width: '7rem' },
    { value: 'importStatus', header: 'Status', width: '7rem' },
    { value: 'importDescription', header: 'Description', width: '300px' }
  ];
  _invoiceApplicantSelectedColumns: any[];
  _validatedInvoiceApplicantSelectedColumns: any[];
  _processedInvoiceApplicantSelectedColumns: any[];
  _rejectedInvoiceApplicantSelectedColumns: any[];

  constructor(private emailTemplateService: EmailTemplateService,
    private router: Router, private route: ActivatedRoute,
    private _fb: FormBuilder,
    public sharedService: SharedService,
    private importInvoiceApplicantService:ImportInvoiceApplicantService,
    private messageService: MessageService,
    private jwtService:JwtService,
    private confirmationService: ConfirmationService
  ) {
  //  setInterval(() =>  this.checkSessionTimeout(), 60000);
  // router.events.forEach((event) => {
  //   if (event instanceof NavigationStart) {
  //      if ((event['url'] == '/login') || (event['url'] == '/')|| (event['url'] == '/register')|| (event['url'] == '/register-profile')|| (event['url'] == '/forgot-password') || (event['url'] == '/users/new-user-change-password')) {
  //      // this.show = false;
  //      }
  //      else {
  //       var isTokenAvailable = this.sharedService.isTokenAvailable();
         
  //       if(isTokenAvailable){
  //       setInterval(() =>  this.checkSessionTimeout(), 60000);
  //       }
      
  //      }
  //     }
  // });
   }

  ngOnInit(): void {
    this.checkViewPermission();
    this.InitialSetup();
    this._invoiceApplicantSelectedColumns = this.invoiceApplicantAllColumns;
    this._validatedInvoiceApplicantSelectedColumns = this.validatedInvoiceApplicantAllColumns;
    this._processedInvoiceApplicantSelectedColumns = this.processedInvoiceApplicantAllColumns;
    this._rejectedInvoiceApplicantSelectedColumns = this.rejectedInvoiceApplicantAllColumns;
  }

  checkSessionTimeout()
    {
      var isTokenAvailable = this.sharedService.isTokenAvailable();
      if(isTokenAvailable){
        var result = this.sharedService.checkSessionTimeout();
       
         if(!result) {
           localStorage.removeItem('VMS');
           this.router.navigateByUrl('/login');
         }
      }    
    }
    
  @Input() get invoiceApplicantSelectedColumns(): any[] {
    return this._invoiceApplicantSelectedColumns;
  }

  set invoiceApplicantSelectedColumns(val: any[]) {
    this._invoiceApplicantSelectedColumns = this.invoiceApplicantAllColumns.filter(col => val.includes(col));
  }

  @Input() get validatedInvoiceApplicantSelectedColumns(): any[] {
    return this._validatedInvoiceApplicantSelectedColumns;
  }

  set validatedInvoiceApplicantSelectedColumns(val: any[]) {
    this._validatedInvoiceApplicantSelectedColumns = this.validatedInvoiceApplicantAllColumns.filter(col => val.includes(col));
  }

  @Input() get processedInvoiceApplicantSelectedColumns(): any[] {
    return this._processedInvoiceApplicantSelectedColumns;
  }

  set processedInvoiceApplicantSelectedColumns(val: any[]) {
    this._processedInvoiceApplicantSelectedColumns = this.processedInvoiceApplicantAllColumns.filter(col => val.includes(col));
  }

  @Input() get rejectedInvoiceApplicantSelectedColumns(): any[] {
    return this._rejectedInvoiceApplicantSelectedColumns;
  }

  set rejectedInvoiceApplicantSelectedColumns(val: any[]) {
    this._rejectedInvoiceApplicantSelectedColumns = this.rejectedInvoiceApplicantAllColumns.filter(col => val.includes(col));
  }

  checkViewPermission() {
    var result = this.sharedService.checkPermission("Admin_View");
    if (!result)
      this.router.navigateByUrl('/login');
  }

  InitialSetup(){
    this.importInvoiceApplicantForm = this._fb.group({
      file: new FormControl("",[Validators.required])
    })
  }


  onImportInvoiceSelect(event) {
    const target: DataTransfer = <DataTransfer>(event.target);
    if (target.files.length == 1 && (target.files[0].type == ".xlsx" || target.files[0].type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || target.files[0].type == "application/vnd.ms-excel")) {
      this.importInvoiceFile = event.target.files[0];
      this.uploadedFileName = event.target.files[0].name;
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(this.importInvoiceFile);
      fileReader.onload = (e) => {
        this.arrayBuffer = fileReader.result;
        var data = new Uint8Array(this.arrayBuffer);
        var arr = new Array();
        for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
        var bstr = arr.join("");
        var workbook = XLSX.read(bstr, { type: 'binary',cellText:false ,cellDates:true });
        var first_sheet_name = workbook.SheetNames[0];
        var worksheet = workbook.Sheets[first_sheet_name];
        this.arraylist = XLSX.utils.sheet_to_json(worksheet, { defval: null, raw: false, blankrows:false, dateNF:'MM/DD/YYYY' });
      }
    } else {
       this.InitialSetup();
       this.messageService.add({severity:'error', summary:'Rejected', detail:'Invalid file format. Only .xlsx and .xls are allowed'});
    }
  }

  save() {
    var re = /-/gi; 
    this.disableImportBtn = true;
    this.isShowInputTable = true;
    this.loading = true;
    for (const iapplicant of this.arraylist) {
     // console.log(iapplicant);
      // console.log(Object.keys(iapplicant));
      // console.log(Object.values(iapplicant));
      const indValues : any = Object.values(iapplicant);
   //   this.invoiceApplicants.push(iapplicant);
      this.invoiceApplicants.push({
        rowId: indValues[0],
        //firstName: indValues[1],
        //lastName: indValues[2],
        firstName: indValues[1].trim().charAt(0).toUpperCase() + indValues[1].trim().slice(1).toLowerCase(),
        lastName: indValues[2].trim().charAt(0).toUpperCase() + indValues[2].trim().slice(1).toLowerCase(),
        email: indValues[3],
        phone: indValues[4],
        stateName: indValues[5],
        city: indValues[6],
        experience:indValues[7],
        applicantClassification: indValues[8],
        availableStatus: indValues[9],
        hourlyBillRate: indValues[10],
        residentialStatus: indValues[11],
        requisitionTitle: indValues[12],
        billRate: indValues[13],
        jobCategory: indValues[14],
        contractType: indValues[15],
        jobSite: indValues[16],
        payType:indValues[17],
        hireType:indValues[18],
        clientName: indValues[19],
        clientDepartment : indValues[20],
        vendorName: indValues[21],
        startDate: indValues[22].replace(re,'/'),
        endDate: indValues[23].replace(re,'/'),
        importStatus: "",
        importDescription: ""
      });
      //set row id
      let id = 1
      this.invoiceApplicants.forEach(item => {
        item.rowId  = id;
        id++;
      })

     
    }
    var isClientValidate : boolean = true;
    var status : string = '';
    for (let iapplicant of this.invoiceApplicants) {
      status ='';
      if (isNullValidator(iapplicant.email)){
        status = " Invalid/Missing Email ,";
          isClientValidate = false;
      } else  if (!EmailValidator(iapplicant.email)){
        status += "  Invalid/Missing Email ,";
          isClientValidate = false;
      }
      if (isNullValidator(iapplicant.firstName)){
        status += "   Invalid/Missing First Name  ,";
          isClientValidate = false;
      } else if (!NameValidator(iapplicant.firstName)){
        status += "   Invalid/Missing First Name  ,";
        isClientValidate = false;
      }
      else if (!ApplicantNameValidator(iapplicant.firstName)){
        status += "   Invalid/Missing First Name  ,";
        isClientValidate = false;
      }
      if (isNullValidator(iapplicant.lastName)){
        status += "   Invalid/Missing Last Name  ,";
          isClientValidate = false;
      } else if (!NameValidator(iapplicant.lastName)){
        status += "  Invalid/Missing Last Name  ,";
            isClientValidate = false;
      }else if (!ApplicantNameValidator(iapplicant.lastName)){
        status += "   Invalid/Missing Last Name  ,";
        isClientValidate = false;
      }
      if (isNullValidator(iapplicant.phone)){
        status += "  Invalid/Missing Phone no  ,";
          isClientValidate = false;
      } else if (!PhoneValidator(iapplicant.phone)){
           status += " Invalid/Missing Phone no ,";
           isClientValidate = false;
      }
      if (isNullValidator(iapplicant.hourlyBillRate)){
        status += "Invalid/Missing Hourly Bill Rate  ,";
          isClientValidate = false;
      } else if (!BillRateValidator(iapplicant.hourlyBillRate)){
        status += "Invalid/Missing Hourly Bill Rate  ,";
        isClientValidate = false;
      }
      if (isNullValidator(iapplicant.billRate)){
        status += "  Invalid/Missing Req. Bill Rate  ,";
          isClientValidate = false;
      } else if (!BillRateValidator(iapplicant.billRate)){
         status += "  Invalid/Missing Req. Bill Rate  ,";
         isClientValidate = false;
      }

      if (isNullValidator(iapplicant.applicantClassification)){
        status += " Invalid/Missing Applicant Classification  ,";
          isClientValidate = false;
      } 
      
      if (isNullValidator(iapplicant.availableStatus)){
        status += " Invalid/Missing Available Status  ,";
          isClientValidate = false;
      } 

      if (isNullValidator(iapplicant.city)){
        status += "  Invalid/Missing City  ,";
          isClientValidate = false;
      } 
      if (isNullValidator(iapplicant.clientName)){
        status += " Invalid/Missing Client  ,";
          isClientValidate = false;
        } 
        if (isNullValidator(iapplicant.clientDepartment)){
          status += " Invalid/missing client department  ,";
            isClientValidate = false;
          } 
      if (isNullValidator(iapplicant.contractType)){
        status += " Invalid/Missing Contract Type  ,";
          isClientValidate = false;
        } 
        // else if (!NameValidator(iapplicant.contractType)){
        //   status += "Contract Type is not valid";
        //   isClientValidate = false;
        // }   

      if (isNullValidator(iapplicant.endDate)){
        status += "  Invalid/Missing Est. End Date  ,";
          isClientValidate = false;
      } 
      if (isNullValidator(iapplicant.experience)){
        status += " Invalid/Missing Experience  ,";
          isClientValidate = false;
      } else if (!ExperienceValidator(iapplicant.experience)){
        status += "  Invalid/Missing Experience  ,";
        isClientValidate = false;
     }
      if (isNullValidator(iapplicant.hireType)){
        status += " Invalid/Missing Hire Type  ,";
          isClientValidate = false;
        } 

      if (isNullValidator(iapplicant.jobCategory)){
        status += " Invalid/Missing Job Category  ,";
          isClientValidate = false;
      } 

      if (isNullValidator(iapplicant.jobSite)){
        status += " Invalid/Missing Job Site  ,";
          isClientValidate = false;
      } 
      if (isNullValidator(iapplicant.payType)){
        status += " Invalid/Missing Pay Type";
          isClientValidate = false;
      } 

      if (isNullValidator(iapplicant.requisitionTitle)){
        status += " Invalid/Missing Requisition Title  ,";
          isClientValidate = false;
      } 

      if (isNullValidator(iapplicant.residentialStatus)){
        status += " Invalid/Missing Residential Status  ,";
          isClientValidate = false;
      } 

      if (isNullValidator(iapplicant.startDate)){
        status += " Invalid/Missing Start Date  ,";
          isClientValidate = false;
      } 
      if (isNullValidator(iapplicant.stateName)){
        status += " Invalid/Missing State Name  ,";
          isClientValidate = false;
      } 
      if (isNullValidator(iapplicant.vendorName)){
        status += " Invalid/Missing Vendor Name  ,";
        isClientValidate = false;
      } 

      if(!isCompareDateValidator(iapplicant.startDate,iapplicant.endDate)) {
        status += " Contract End date less than StartDate  ,";
        isClientValidate = false;
      }
      if (status.length>0) {
        iapplicant.importStatus = "Fail";
      iapplicant.importDescription = status.slice(0, -1);
      } else {
        iapplicant.importStatus = "Pass";
        iapplicant.importDescription = "Ready to import";
      }
      
  }
  //console.log(this.invoiceApplicants);
  var loggedInUser = this.jwtService.getLoggedInUserProfileId();
  if (loggedInUser == 0) {
        this.jwtService.destroyToken();
        this.router.navigateByUrl('/login');
  }
    if (isClientValidate == true) {
      let tmpImportInvoicedApplicants = <ImportInvoicedApplicants>{}
      tmpImportInvoicedApplicants.userProfileId =loggedInUser;
      tmpImportInvoicedApplicants.inputInvoicedApplicants = this.invoiceApplicants;
      tmpImportInvoicedApplicants.processedApplicants = null;
      tmpImportInvoicedApplicants.rejectedApplicants = null;
      this.importInvoicedApplicants = tmpImportInvoicedApplicants;
    //  checkImportApplicants
    var applicantName : any = '';
    var vendorName  : any = '';
      this.importInvoiceApplicantService.checkImportApplicants(this.importInvoicedApplicants).subscribe((data: ImportInvoicedApplicants) => {
     //  console.log(data.rejectedApplicants.length);
       if(data.rejectedApplicants.length >0) {
        for (const iapplicant of data.rejectedApplicants) {
           applicantName  += iapplicant.firstName + ' ' + iapplicant.lastName + ', ';
           vendorName += iapplicant.vendorName + ', ';
        }
      
        this.confirmationService.confirm(
          {
            message: 'The applicant: ' + applicantName.slice(0,-2) + ' is already available for the vendor: ' + vendorName.slice(0,-2) + '.Do you want to import this applicant for a different submission record?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
              tmpImportInvoicedApplicants.isAlreadyapplicant = 'Yes';
        this.processImportApplicants(tmpImportInvoicedApplicants);
            },
            reject: (type) => {
              tmpImportInvoicedApplicants.isAlreadyapplicant = 'No';
              this.processImportApplicants(tmpImportInvoicedApplicants);
            }
          }
        );
       } else {
        tmpImportInvoicedApplicants.isAlreadyapplicant = 'No';
        this.processImportApplicants(tmpImportInvoicedApplicants);
       }
    }, err => {
      console.log(err)
    });
  //}
      
      // this.processedApplicants = this.invoiceApplicants;
      // this.rejectedApplicants = this.invoiceApplicants;
      this.isShowResultTable = true;
    } else {
      this.displayErrorModal = true;
      this.validatedApplicants = this.invoiceApplicants;
      this.isValidateTable = true;

    }
    this.loading = false;
  }

  processImportApplicants(importInvoicedApplicants){
  for(var l=0;l<importInvoicedApplicants.inputInvoicedApplicants.length;l++)
  {
    var splitExperience = (importInvoicedApplicants.inputInvoicedApplicants[l].experience).toString().split('.',2);
    if(splitExperience[1] != undefined)
    {
      if(Number(splitExperience[1]) < 10)
      {
        var zerofilled = ('0'+ splitExperience[1]).slice(-2);
      }
      if(zerofilled != undefined)
      {
        importInvoicedApplicants.inputInvoicedApplicants[l].experience = Number(splitExperience[0] +'.' + zerofilled);
      }
    }
  }
  this.importInvoiceApplicantService.importInvoice(importInvoicedApplicants).subscribe((data: ImportInvoicedApplicants) => {
        this.isShowResultTable = true;
        this.isValidateTable = false;
        this.processedApplicants = data.processedApplicants;
      //  this.rejectedApplicants = data.rejectedApplicants;

        for (const iapplicant of data.rejectedApplicants) {
          this.rejectedApplicants.push({
            rowId: iapplicant.rowId,
            firstName: iapplicant.firstName,
            lastName: iapplicant.lastName,
            phone: iapplicant.phone,
            email: iapplicant.email,
            stateName: iapplicant.stateName,
            city: iapplicant.city,
            experience: iapplicant.experience,
            applicantClassification: iapplicant.applicantClassification,
            availableStatus: iapplicant.availableStatus,
            hourlyBillRate: iapplicant.hourlyBillRate,
            residentialStatus: iapplicant.residentialStatus,
            requisitionTitle: iapplicant.requisitionTitle,
            billRate: iapplicant.billRate,
            jobCategory: iapplicant.jobCategory,
            contractType: iapplicant.contractType,
            jobSite: iapplicant.jobSite,
            payType:iapplicant.payType,
            hireType:iapplicant.hireType,
            clientName: iapplicant.clientName,
            clientDepartment : iapplicant.clientDepartment,
            vendorName: iapplicant.vendorName,
            startDate: iapplicant.startDate.slice(1),
            endDate: iapplicant.endDate.slice(1),
            importStatus: iapplicant.importStatus,
            importDescription: iapplicant.importDescription
          });
          
    
         
        }
      }, err => {
        console.log(err)
      });
  }

  cancel() {
    //this.sharedService.backToPrevPage();
    this.InitialSetup();
    this.uploadedFileName = "";
    this.isShowResultTable = false;
    this.isValidateTable = false;
    this.disableImportBtn = false;
    this.invoiceApplicants = [];
    this.validatedApplicants = [];
    this.processedApplicants = [];
    this.rejectedApplicants = [];
    this.importInvoicedApplicants = <ImportInvoicedApplicants>{};
    this.loading = false;
    this.isShowInputTable = false;
  }

  downloadSampleFile(){
    let link = document.createElement("a");
    link.download = "ApplicantImport.xlsx";
    link.href = "assets/helpfiles/ApplicantImport.xlsx";
    link.click();
  }

  exportexcel(): void
  {
    /* pass here the table id */
    let element = this.rejectedApplicants;
    
 
    const Heading = [
      ['Row Id', 'First Name', 'Last Name',  'Phone', 'Email', 'State', 'City',
       'Experience', 'Applicant Classification', 'Available Status', 'Hourly Bill Rate', 'Residential Status', 
       'Requisition Title', 'Req. Bill Rate','Job Category','Contract Type',
       'Job Site','Pay Type','Hire Type','Client','Client Dept','Vendor','Start Date','Est. End Date','Status','Description']
    ];

   
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet( this.rejectedApplicants);

    XLSX.utils.sheet_add_aoa(ws, Heading, { origin: 'A1' });

    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
    /* save to file */  
    XLSX.writeFile(wb, "RejectApplicant.xlsx");
 
  }
}
